package ru.playa.sce.dto

enum class Privilege(val displayName: String) {
    READ("Смотреть"),
    EDIT("Редактировать"),
    CREATE("Добавлять"),
    DELETE("Удалять"),
    APPROVE("Утверждать"),
    PUBLISH("Публиковать")
}